import React from 'react';
import './NoDataComponent.scss';

type Props = {
  title: string;
  bodyContent: string;
  noDataImg: any;
  buttonProps?: any;
};

const NoDataComponent = (props: Props) => {
  const { title, bodyContent, noDataImg, buttonProps } = props;

  const handleClick = () => {
    buttonProps.onClick();
  };

  return (
    <div className="nd-ctn">
      <div className="nd-sub-ctn">
        {noDataImg && (
          <div className="nd-img">
            <img src={noDataImg} alt="" />
          </div>
        )}
        <div className="nd-title">{title}</div>
        <div className="nd-bc">{bodyContent}</div>
        {buttonProps && (
          <button
            className={'cb cb-variant-2'}
            onClick={handleClick}
            type='button'
            >
            {buttonProps.text}
          </button>
        )}
      </div>
    </div>
  );
};

export default NoDataComponent;